export default {

	callbacks: [],

	add(fn) {
		this.callbacks.push(fn)
		return fn
	},

	remove(fn) {
		let rm = this.callbacks.indexOf(fn)
		if (rm !== -1) {
			return this.callbacks.splice(rm, 1)
		}
		return null
	},

	update(delta) {
		if (this.callbacks.length < 1) return
		for (let i = 0; i < this.callbacks.length; i++) {
			this.callbacks[i](delta)
		}
	},

}



// WEBPACK FOOTER //
// ./src/utils/animator.js